import { Link, useLocation } from 'react-router-dom';

import { mergeQueryStringAndQueryObject, whitelistQueryString } from '../queryStringUtils';
import { deeplinkUrl } from '../deeplinkUtils';
import { IS_USER_AGENT_WITH_AVAILABLE_APP } from '../userAgentUtils';
import { useAppDispatch } from '../contexts/AppStateContext';
import ExternalLink from './ExternalLink';
import { SyncReactNode } from '../types';

type Props = {
  campaign: string;
  deeplink?: string;
  className?: string;
  children: SyncReactNode;
};

const ResponsiveLink = ({ campaign, deeplink, className, children }: Props) => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  return IS_USER_AGENT_WITH_AVAILABLE_APP ? (
    <ExternalLink className={className} href={deeplinkUrl(campaign, deeplink)}>
      {children}
    </ExternalLink>
  ) : (
    <Link
      className={className}
      to={`/cta${mergeQueryStringAndQueryObject(whitelistQueryString(location.search), { campaign })}`}
      onClick={() => {
        dispatch({ type: 'cardPropertiesChanged', cardProperties: { stackSize: 2 } });
      }}
    >
      {children}
    </Link>
  );
};

export default ResponsiveLink;
